import { activitiesWithEarlyFinishTime } from 'config/widgetConfigurations/widgets/activitiesWithEarlyFinishTimeConfig';
import { activitiesWithLateStartTime } from 'config/widgetConfigurations/widgets/activitiesWithLateStartTimeConfig';
import { activityPredecessors } from 'config/widgetConfigurations/widgets/activityPredecessorsConfig';
import { allScheduleQualityChecks } from 'config/widgetConfigurations/widgets/allScheduleQualityChecksConfig';
import { automatedNarrative } from 'config/widgetConfigurations/widgets/automatedNarrativeConfig';
import { baselineExecutionIndex } from 'config/widgetConfigurations/widgets/baselineExecutionIndexConfig';
import { battlecardsRowsBoard } from 'config/widgetConfigurations/widgets/battlecardsRowsBoardConfig';
import { changeSummary } from 'config/widgetConfigurations/widgets/changeSummaryConfig';
import { changedActivities } from 'config/widgetConfigurations/widgets/changedActivitiesConfig';
import { constraintsWithoutRelationship } from 'config/widgetConfigurations/widgets/constraintsWithoutRelationshipConfig';
import { criticalPathAdded } from 'config/widgetConfigurations/widgets/criticalPathAddedConfig';
import { criticalPathCongestion } from 'config/widgetConfigurations/widgets/criticalPathCongestionConfig';
import { criticalPathLengthIndex } from 'config/widgetConfigurations/widgets/criticalPathLengthIndexConfig';
import { criticalPathRemoved } from 'config/widgetConfigurations/widgets/criticalPathRemovedConfig';
import { criticalPathTest } from 'config/widgetConfigurations/widgets/criticalPathTestConfig';
import { criticalityWeightedSCurve } from 'config/widgetConfigurations/widgets/criticalityWeightedSCurveConfig';
import { currentSpi } from 'config/widgetConfigurations/widgets/currentSpiConfig';
import { customReportText } from 'config/widgetConfigurations/widgets/customReportTextConfig';
import { danglingLogic } from 'config/widgetConfigurations/widgets/danglingLogicConfig';
import { dataStories } from 'config/widgetConfigurations/widgets/dataStoriesConfig';
import { duplicateRelations } from 'config/widgetConfigurations/widgets/duplicateRelationsConfig';
import { finishDateActivitiesPredecessors } from 'config/widgetConfigurations/widgets/finishDateActivitiesPredecessorsConfig';
import { finishDateFuturePotentialDelayDrivers } from 'config/widgetConfigurations/widgets/finishDateFuturePotentialDelayDriversConfig';
import { finishDateOverallSummary } from 'config/widgetConfigurations/widgets/finishDateOverallSummaryConfig';
import { frequentlyUsedResources } from 'config/widgetConfigurations/widgets/frequentlyUsedResourcesConfig';
import { ganttChart } from 'config/widgetConfigurations/widgets/ganttChartConfig';
import { hardConstraints } from 'config/widgetConfigurations/widgets/hardConstraintsConfig';
import { highFloatByActivityType } from 'config/widgetConfigurations/widgets/highFloatByActivityTypeConfig';
import { highLevelProgramLatest } from 'config/widgetConfigurations/widgets/highLevelProgramLatestConfig';
import { incompleteWithFinishDate } from 'config/widgetConfigurations/widgets/incompleteWithFinishDateConfig';
import { invalidActualDates } from 'config/widgetConfigurations/widgets/invalidActualDatesConfig';
import { invalidForecastDates } from 'config/widgetConfigurations/widgets/invalidForecastDatesConfig';
import { keyAchievements } from 'config/widgetConfigurations/widgets/keyAchievementsConfig';
import { keyActivities } from 'config/widgetConfigurations/widgets/keyActivitiesConfig';
import { lags } from 'config/widgetConfigurations/widgets/lagsConfig';
import { largestAddedActivities } from 'config/widgetConfigurations/widgets/largestAddedActivitiesConfig';
import { largestDeletedActivities } from 'config/widgetConfigurations/widgets/largestDeletedActivitiesConfig';
import { largestDurationVariance } from 'config/widgetConfigurations/widgets/largestDurationVarianceConfig';
import { largestFloatChanges } from 'config/widgetConfigurations/widgets/largestFloatChangesConfig';
import { leads } from 'config/widgetConfigurations/widgets/leadsConfig';
import { longDuration } from 'config/widgetConfigurations/widgets/longDurationConfig';
import { milestonesWeightedSCurve } from 'config/widgetConfigurations/widgets/milestonesWeightedSCurveConfig';
import { missedActivities } from 'config/widgetConfigurations/widgets/missedActivitiesConfig';
import { missingBaselineDates } from 'config/widgetConfigurations/widgets/missingBaselineDatesConfig';
import { mySummaryTrackedActivities } from 'config/widgetConfigurations/widgets/mySummaryTrackedActivitiesConfig';
import { myVersionCompareTrackedActivities } from 'config/widgetConfigurations/widgets/myVersionCompareTrackedActivitiesConfig';
import { negativeFloatByActivityType } from 'config/widgetConfigurations/widgets/negativeFloatByActivityTypeConfig';
import { outOfSequence } from 'config/widgetConfigurations/widgets/outOfSequenceConfig';
import { overallStatus } from 'config/widgetConfigurations/widgets/overallStatusConfig';
import { phasePerformanceBreakdown } from 'config/widgetConfigurations/widgets/phasePerformanceBreakdownConfig';
import { phasePerformanceChart } from 'config/widgetConfigurations/widgets/phasePerformanceChartConfig';
import { prioritiesMatrix } from 'config/widgetConfigurations/widgets/prioritiesMatrixConfig';
import { productivityRate } from 'config/widgetConfigurations/widgets/productivityRateConfig';
import { productivityRiskKpi } from 'config/widgetConfigurations/widgets/productivityRiskKpiConfig';
import { productivityRiskTrend } from 'config/widgetConfigurations/widgets/productivityRiskTrendConfig';
import { productivityTable } from 'config/widgetConfigurations/widgets/productivityTableConfig';
import { progressSummary } from 'config/widgetConfigurations/widgets/progressSummaryConfig';
import { projectScorecards } from 'config/widgetConfigurations/widgets/projectScorecardsConfig';
import { projectSummary } from 'config/widgetConfigurations/widgets/projectSummaryConfig';
import { rarelyUsedResources } from 'config/widgetConfigurations/widgets/rarelyUsedResourcesConfig';
import { relationshipTypes } from 'config/widgetConfigurations/widgets/relationshipTypesConfig';
import { relationshipsActivitiesRatio } from 'config/widgetConfigurations/widgets/relationshipsActivitiesRatioConfig';
import { reportSummary } from 'config/widgetConfigurations/widgets/reportSummaryConfig';
import { resourcesAnalysisChart } from 'config/widgetConfigurations/widgets/resourcesAnalysisChartConfig';
import { resourcesAnalysisTable } from 'config/widgetConfigurations/widgets/resourcesAnalysisTableConfig';
import { riskHeatMap } from 'config/widgetConfigurations/widgets/riskHeatMapConfig';
import { riskRegister } from 'config/widgetConfigurations/widgets/riskRegisterConfig';
import { scheduleDelay } from 'config/widgetConfigurations/widgets/scheduleDelayConfig';
import { scheduleQualityScore } from 'config/widgetConfigurations/widgets/scheduleQualityScoreConfig';
import { scheduleQualityTrend } from 'config/widgetConfigurations/widgets/scheduleQualityTrendConfig';
import { sensitiveActivitiesByDuration } from 'config/widgetConfigurations/widgets/sensitiveActivitiesByDurationConfig';
import { sharedResourcesAvailability } from 'config/widgetConfigurations/widgets/sharedResourcesAvailabilityConfig';
import { softConstraints } from 'config/widgetConfigurations/widgets/softConstraintsConfig';
import { spiTrend } from 'config/widgetConfigurations/widgets/spiTrendConfig';
import { startFinishTimeNotRound } from 'config/widgetConfigurations/widgets/startFinishTimeNotRoundConfig';
import { timelineAndDensity } from 'config/widgetConfigurations/widgets/timelineAndDensityConfig';
import { topCriticalActivitiesDelayDrivers } from 'config/widgetConfigurations/widgets/topCriticalActivitiesDelayDriversConfig';
import { topDurationOverrunRisk } from 'config/widgetConfigurations/widgets/topDurationOverrunRiskConfig';
import { topFinishDateChanges } from 'config/widgetConfigurations/widgets/topFinishDateChangesConfig';
import { topOverdueOverrunActivities } from 'config/widgetConfigurations/widgets/topOverdueOverrunActivitiesConfig';
import { topRecommendations } from 'config/widgetConfigurations/widgets/topRecommendationsConfig';
import { topRelationshipsCountChanges } from 'config/widgetConfigurations/widgets/topRelationshipsCountChangesConfig';
import { topRelationshipsTypeChanges } from 'config/widgetConfigurations/widgets/topRelationshipsTypeChangesConfig';
import { topStartDateChanges } from 'config/widgetConfigurations/widgets/topStartDateChangesConfig';
import { topStatusChanges } from 'config/widgetConfigurations/widgets/topStatusChangesConfig';
import { trends } from 'config/widgetConfigurations/widgets/trendsConfig';
import { unresourcedActivities } from 'config/widgetConfigurations/widgets/unresourcedActivitiesConfig';
import { workSettingsApplied } from 'config/widgetConfigurations/widgets/workSettingsAppliedConfig';

import { IHashmap } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export type WidgetsMapComponentKeys = keyof IHashmap;

export const widgetsConfigurations: IHashmap = {
    riskHeatMap,
    criticalityWeightedSCurve,
    topCriticalActivitiesDelayDrivers,
    topDurationOverrunRisk,
    progressSummary,
    topOverdueOverrunActivities,
    highLevelProgramLatest,
    milestonesWeightedSCurve,
    mySummaryTrackedActivities,
    myVersionCompareTrackedActivities,
    topStatusChanges,
    topStartDateChanges,
    topFinishDateChanges,
    largestDurationVariance,
    largestFloatChanges,
    topRelationshipsTypeChanges,
    topRelationshipsCountChanges,
    largestAddedActivities,
    largestDeletedActivities,
    criticalPathAdded,
    criticalPathRemoved,
    topRecommendations,
    changeSummary,
    projectSummary,
    spiTrend,
    productivityRiskTrend,
    scheduleQualityTrend,
    prioritiesMatrix,
    keyAchievements,
    projectScorecards,
    overallStatus,
    dataStories,
    battlecardsRowsBoard,
    phasePerformanceChart,
    phasePerformanceBreakdown,
    activityPredecessors,
    ganttChart,
    sharedResourcesAvailability,
    keyActivities,
    timelineAndDensity,
    finishDateOverallSummary,
    finishDateActivitiesPredecessors,
    finishDateFuturePotentialDelayDrivers,
    changedActivities,
    resourcesAnalysisTable,
    productivityTable,
    productivityRate,
    resourcesAnalysisChart,
    trends,
    riskRegister,
    customReportText,
    scheduleQualityScore,
    currentSpi,
    scheduleDelay,
    productivityRiskKpi,
    automatedNarrative,
    outOfSequence,
    danglingLogic,
    leads,
    lags,
    relationshipTypes,
    hardConstraints,
    highFloatByActivityType,
    negativeFloatByActivityType,
    longDuration,
    invalidActualDates,
    invalidForecastDates,
    unresourcedActivities,
    missedActivities,
    criticalPathTest,
    criticalPathLengthIndex,
    baselineExecutionIndex,
    missingBaselineDates,
    duplicateRelations,
    softConstraints,
    allScheduleQualityChecks,
    reportSummary,
    criticalPathCongestion,
    incompleteWithFinishDate,
    constraintsWithoutRelationship,
    sensitiveActivitiesByDuration,
    workSettingsApplied,
    startFinishTimeNotRound,
    activitiesWithEarlyFinishTime,
    activitiesWithLateStartTime,
    frequentlyUsedResources,
    rarelyUsedResources,
    relationshipsActivitiesRatio,
};
